

export enum LayoutTypeMetadata {

    Section = "SECTION_LAYOUT",
    Row = "ROW_LAYOUT",
    Repeat = "REPEAT_LAYOUT",
    Table = "TABLE_LAYOUT",
    WebService = "WEBSERVICE_LAYOUT"

}

export function ToLayoutTypeMetadata(type: string): LayoutTypeMetadata | null {
    switch (type) {
        case "SECTION_LAYOUT":
            return LayoutTypeMetadata.Section
        case "ROW_LAYOUT":
            return LayoutTypeMetadata.Row
        case "REPEAT_LAYOUT":
            return LayoutTypeMetadata.Repeat
        case "TABLE_LAYOUT":
            return LayoutTypeMetadata.Table
        case "WEBSERVICE_LAYOUT":
            return LayoutTypeMetadata.WebService
    }

    return null
}

export const LAYOUT_TYPES_METADATA: LayoutTypeMetadata[] = [
    LayoutTypeMetadata.Section,
    LayoutTypeMetadata.Row,
    LayoutTypeMetadata.Repeat,
    LayoutTypeMetadata.Table,
    LayoutTypeMetadata.WebService
]